import { VariationType } from '../domain/models/ab-test-options.model';

export abstract class AbTestStorageService {
  public abstract get(name: string): VariationType | undefined;
  public abstract set(name: string, value: VariationType, expires: number): void;
}
